/*
 * Created by jmeo at 2021-06-02
 * FileName: Entrust.tsx
 * 个人征信授权书
 */

import {setTitle} from "@src/util";
import CustomScroll from '@src/component/customScroll'
export default function () {
    setTitle('个人征信授权书')
    return <div className="page bottomFit"><CustomScroll><div className="agreement">
        <h2>个人征信授权书</h2>
        <p><strong>重要提示：</strong></p>
        <p><strong>尊敬的客户：为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别是黑体字条款），关注您在授权书中的权利、义务。</strong></p>
        <p><strong>除非您已阅读并接受本授权书所有条款，否则您无权使用本次服务。您的使用、登录等行为即视为您已阅读并同意本授权书条款的约束。</strong></p>
        <p><strong>深圳市华融融资担保有限公司：</strong></p>
        <p><strong>一、本人不可撤销地授权贵司在向本人提供金融产品和金融服务以及与贵司开展其他业务过程中，有权按照相关法律、法规和监管要求规定，查询、使用、打印、报送本人全部或部分信息，具体约定如下：</strong></p>
        <p>本人同意并授权贵司以合法手段自行或向中国人民银行金融信用信息基础数据库或其他相关机构（包括但不限于金融机构、税务、工商、人民法院、征信机构及其他监管部门、行业自律机构及贵司及/或合作平台等）采集、处理、查询、获取、验证、加工本人的基本信息（包括但不限于本人姓名、证件类型、证件号码、通讯录联系方式、通讯录、通话详单、短信、财产状况、行踪轨迹、借款和还款信息、逾期信息、车辆位置及GPS信息、银行卡号及各类银行卡在商业活动中形成的交易记录、职业和居住地址等）、个人征信相关信息及其他反映本人信用状况的信息（包括但不限于个人身份信息、不良信用记录、社会保险及公积金信息，芝麻信用信息、以及视情况查询本人的收入、存款、有价证券、商业保险、不动产的信息和纳税数额信息、以虚假身份申请借款（如有）、提供虚假申请资料等欺诈信息（如有）等全部信息），并授权贵公司向上述机构及/或贵公司、合作平台的合作机构披露或报送、留存、加工、查询、验证上述信息。</p>
        <p>如本人在金融信用信息基础数据库中存在曾用名记录，则本人授权贵公司直接使用曾用名信息进行查询，而无须本人另行办理授权。</p>
        <p>本人授权贵公司及合作平台有权基于为本人提供相应的金融服务之目的，与贵公司及合作平台的合作机构共享本人的上述信息。授权贵公司及合作平台有权向本人收集相关主体信息（包括但不限于本人的人像照片及其身份信息），并将上述信息提供给贵公司及合作平台的合作机构，并由合作机构对上述信息进行核查、验证、比对识别并向贵公司输出、展示验证结果。贵公司已明确告知本人上述信息的提供可能会对本人产生不利后果，本人准确、完整了解本项授权的含义，确认对贵公司及合作平台作出前述授权。</p>
        <p><strong>二、若本人申请的上述业务未获贵司及/或合作平台等批准办理，则本授权书及形成的本人信用报告等资料均无须退回本人，但贵司应按照相关法律法规、规范性文件以及贵司相关制度的规定妥善保管或销毁。</strong></p>
        <p><strong>三、本授权书内容与相关业务的合同条款不一致的，无论相关合同在本授权书之前或之后签署，均应以本授权书的内容为准，但相关合同条款明确约定是针对本授权书内容所做修订的除外。</strong></p>
        <p><strong>四、贵司超出上述授权查询、使用、报送本人信息的一切后果和法律责任由贵司承担。</strong></p>
        <p><strong>五、本授权书自出具之日起生效，在本人接受贵司提供金融产品、金融服务以及与贵司开展其他业务期间持续有效，非经贵司书面同意本授权书不可撤销。</strong></p>
        <p><strong>本人声明：本授权书是本人向深圳市华融融资担保有限公司做出的单方承诺，效力具有独立性，不因任何协议、条款无效而失效。贵司已经依法向本人提示了相关条款，贵司已应本人的要求对上述条款作出相应的说明。本人已经完全知悉并充分理解本授权书条款的内容及相应的法律后果，并愿意接受本授权书条款的约定。</strong></p>
        <p><strong>若本人与被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</strong></p>
        <p><strong>本人已知悉本授权书所有内容（特别是加粗字体内容）的意义以及由此产生的法律效力，自愿作出上述授权，本授权协议书是本人真实的意思表示，本人同意承担由此带来的一切法律后果。</strong></p>
        <p>特此授权！</p>
        <br/>
    </div></CustomScroll></div>
}